import { useAtomValue } from '@exodus/jotai';
import { exodusAtom } from '../core/atoms.js';
export const useExodus = () => useAtomValue(exodusAtom);
